var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "setting-page-content-wrapper audit-logs",
      attrs: { id: "audit-logs" },
    },
    [
      _c("div", { staticClass: "page-header" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("auditLogs.auditLogsTitle"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "subtitle" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("auditLogs.auditLogsSub")) +
              "\n        "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("ve-table", {
            attrs: {
              columns: _vm.getColumns(),
              "table-data": _vm.activities,
              "row-style-option": _vm.rowStyleOption,
              "border-x": true,
              "border-y": true,
              "expand-option": _vm.expandOption,
              "row-key-field-name": "_id",
              id: "audit-logs-table",
              "fixed-header": true,
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "actions" },
            [
              _vm.activities.length
                ? _c(
                    "SupsisButton",
                    {
                      attrs: { primary: "", small: "", disabled: _vm.loading },
                      on: { click: _vm.loadNextPage },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("settings.loadMore")) +
                          "\n            "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }